export function isPositive(number: number) {
  return number > 0;
}
